import axiosCreate from '@/views/clockIn/http/request.js'


const service = axiosCreate({
    baseURL: process.env.VUE_APP_TRIAD,
})


export function demo(data){
    return service({
        url: 'demo100/test1',
        method: 'POST',
        data
    })
}


export function commonTriadServiceAPI(procName, params, pageNum, pageSize) {
    var data = {procName: procName, data: params, pageNum: pageNum, pageSize: pageSize}
    return service({
        url: 'triad',
        method: 'POST',
        data
    })
}